module.exports = __webpack_public_path__ + "static/media/python_logo.65232491.png";